import { Badge, Descriptions, Spin } from "antd";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { getProjectInfoById } from "../../../../../../api/apiCallManager";
import useProjectInfoQuery from "../../../../../../components/hooks/useProjectInfoQuery";
import { isProjectAdmin } from "../../../../../../helpers/authFunctions";

const InfoKeys = {
  projectTitle: "Project Title",
  projectOwner: "Project Owner",
  federatedEngineer: "FL Engineer",
  jiraUrl: "Jira URL",
  mlEngineer: "ML Engineer",
  confluenceUrl: "Confluence URL",
  projectDescription: "Project Description",
  projectStatus: "Project Status",
};

// CollapsibleText Component
const CollapsibleText = ({ value }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const MAX_LENGTH = 100; // Adjust the max length before collapsing

  if (!value) {
    return <>-</>;
  }

  return (
    <div>
      {value.length > MAX_LENGTH ? (
        <>
          {isExpanded ? value : `${value.substring(0, MAX_LENGTH)}...`}
          <span onClick={toggleExpand} className="text-blue-500 cursor-pointer">
            {isExpanded ? " Read Less" : " Read More"}
          </span>
        </>
      ) : (
        <>{value}</>
      )}
    </div>
  );
};

const ProjectSummary = () => {
  const { id } = useParams();
  const {
    data: projectInfoData,
    error,
    isLoading: isProjectSummaryLoading,
  } = useProjectInfoQuery(id, getProjectInfoById);

  const onlyEnablePA = !isProjectAdmin();

  const formatResponse = (items) => {
    const response = [];
    if (items) {
      let keyCount = 1;
      for (const [key, value] of Object.entries(items)) {
        if (InfoKeys.hasOwnProperty(key)) {
          if (key === "projectStatus") {
            response.push({
              key: `${keyCount + Math.random()}`,
              label: `${InfoKeys[key]}`,
              children: (
                <Badge status="processing" text={value ? value : "-"} />
              ),
            });
          } else {
            response.push({
              key: `${keyCount + Math.random()}`,
              label: `${InfoKeys[key]}`,
              // Use CollapsibleText for potentially lengthy text
              children: <CollapsibleText value={value} />,
            });
          }
        }
        keyCount += 1;
      }
    }
    return response;
  };

  return (
    <div className={`p-5 ${onlyEnablePA && "disableAll"}`}>
      {/* {JSON.stringify(projectInfoZustandState)} */}
      <Spin spinning={isProjectSummaryLoading}>
        <Descriptions
          size="middle"
          layout="vertical"
          className="user-table-theme"
          column={{
            xs: 1,
            sm: 2,
            md: 3,
            lg: 3,
            xl: 4,
            xxl: 4,
          }}
          title=""
          bordered
          items={formatResponse(projectInfoData)}
        />
      </Spin>
    </div>
  );
};

export default ProjectSummary;
